export default {
  "menu.CompanyFormSelectPage": "场所选择",
}